var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 4.96875C17.75 10.4375 9.64141 14.8641 9.29609 15.0469C9.20508 15.0958 9.10335 15.1215 9 15.1215C8.89665 15.1215 8.79492 15.0958 8.70391 15.0469C8.35859 14.8641 0.25 10.4375 0.25 4.96875C0.251447 3.68455 0.762235 2.45337 1.6703 1.5453C2.57837 0.637235 3.80955 0.126447 5.09375 0.125C6.70703 0.125 8.11953 0.81875 9 1.99141C9.88047 0.81875 11.293 0.125 12.9062 0.125C14.1904 0.126447 15.4216 0.637235 16.3297 1.5453C17.2378 2.45337 17.7486 3.68455 17.75 4.96875Z",
    fill: "url(#paint0_linear_393_82844)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_393_82844",
    x1: 0.249999,
    y1: 15.1215,
    x2: 19.6909,
    y2: 3.32312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1493"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C71585"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLove);
export default __webpack_public_path__ + "static/media/love.be4cd1d61c9dfd398fc17834ba2d24b2.svg";
export { ForwardRef as ReactComponent };